<template>
  <div>
    <ul class="m-link-list">
      <li class="m-link-list__item" v-for="(link, index) in value" :key="index">
        <a class="m-link-list__link" :href="link.Url" :target="link.Target">{{ link.Name }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true
    }
  }
}
</script>
